import { render } from "./ConfirmationForm.vue?vue&type=template&id=035a6226&ts=true"
import script from "./ConfirmationForm.vue?vue&type=script&lang=ts"
export * from "./ConfirmationForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__